import _ from 'lodash'
import i18n from 'i18next'
import config from '../../config'

// get current locale from i18next and get api locale code from config
// if not exist, use default locale code as fallback
export default function getLocaleParam() {
  const apiLocaleCodes = config.get('locale.config')
  const apiLocaleCode = _.get(apiLocaleCodes, `${i18n.language}.apiLocaleCode`, config.get('api.locale'))
  return apiLocaleCode
}
